import i18next from 'i18next';

export enum AppLanguage {
    czech = 'cs',
    danish = 'da',
    english = 'en',
    finnish = 'fi',
    hungarian = 'hu',
    norwegian = 'nb',
    polish = 'pl',
    romanian = 'ro',
    slovak = 'sk',
    swedish = 'sw',
    espanol = 'es',
}

const getCode = (language: string): AppLanguage => {
    return AppLanguage[language];
};

const changeLanguageByCode = (code: string) => {
    i18next.changeLanguage(code);
};

const changeLanguageByName = (language: AppLanguage) => {
    let code = getCode(language);
    i18next.changeLanguage(code);
};

export default {
    getCode,
    changeLanguageByCode,
    changeLanguageByName,
};
